// extracted by mini-css-extract-plugin
export default {"hed":"yp","blend":"zp","resultsBox":"Ap","left":"Bp","right":"Cp","center":"Ep","base":"Fp","milk":"Gp","text":"Hp","hyroxresult":"Ip","margin":"Jp"};
    if(module.hot) {
      // 1743628922152
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  